
import React, { Component } from "react";
import { CheckboxGroup, Checkbox, VStack, SimpleGrid } from "@chakra-ui/react"
import { Box, HStack, Text, Spacer, Textarea } from "@chakra-ui/react";
import MultiToggle from "react-multi-toggle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "../../../../assets/css/custom-toggle-style.css";

import LocalStorageService from "../../../../services/LocalStorageService";


export default class CheckListBoxInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentHighlightClass: 'highlight',
            currentOption: 'PASS',
            checked: false, // Initialize checked state
            checkedValues: [
                { checked: false, label: "item1", value: "item1" },
                { checked: false, label: "item2", value: "item2" },
                { checked: false, label: "item3", value: "item3" }

            ]
        }

        this.setCheckedItems = this.setCheckedItems.bind(this);
    }

    componentDidMount() {
        var checkedList = this.props.cardValue ?? [];
        var options = [];
        var dataList = [];
        if (this.props.card.dataList)
        {
            dataList = new LocalStorageService().getDataList(this.props.card.dataList, this.props.gcid);
        }
        else if (this.props.card.options)
        {
            dataList = this.props.card.options;
        }

        options = dataList.data.data.map((d) => {return {checked: false, label: d.name, value: d.id}});
        if (checkedList && checkedList.length > 0) 
        {
            options.forEach((option) => {
                if (checkedList.includes(option.value)) {
                        option.checked = true;
                }
            });
        }
        this.setState({ checkedValues: options });
    }


    setCheckedItems(index) 
    {
        var newSet = this.state.checkedValues
        newSet[index].checked = !newSet[index].checked;
        this.setState({checkedValues: newSet});
        // the values are determined only by the checked items
        var values = newSet.filter(item => item.checked).map(item => item.value);
        var isPreInspectReject = values.length > 0;
        this.props.onValueChange(isPreInspectReject, "preinspectreject");
        this.props.onValueChange(values, this.props.card.id);

    }

    render() {
       

        return (
            <VStack>
                <CheckboxGroup >
                    <SimpleGrid columns={5} spacingX="60px" spacingY="20px">
                        {this.state.checkedValues.map((item, index) => (
                            <Checkbox
                                color={"white"}
                                isChecked={item.checked}
                                onChange={() => this.setCheckedItems(index)}
                            >
                                {item.value}
                            </Checkbox>
                        ))}
                    </SimpleGrid>
                </CheckboxGroup>
            </VStack>

        )
    }
}